import arrayReduce from 'fast-loops/lib/arrayReduce';

export default function applyKeysInOrder(order) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return arrayReduce(order, function (mediaMap, query) {
    mediaMap[query] = initialValue;
    return mediaMap;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-monolithic/node_modules/fela-utils/es/applyKeysInOrder.js
// module id = 316
// module chunks = 0